(() => {
  const DETECT_INTERVAL = 120;
  let running = false, stream = null, lastTs = 0;
  let animationId = null;

  // UI
  const overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);display:none;align-items:center;justify-content:center;z-index:9999';
overlay.innerHTML = `
  <div style="
    background:#111;
    border-radius:12px;
    overflow:auto;                  /* 避免小屏幕按钮被挤出 */
    max-width:92vw;                 /* 最大宽度 */
    width:520px;                    /* 桌面默认宽度 */
    max-height:80vh;                /* 高度最多 80% 屏幕 */
    display:flex;flex-direction:column;
  ">
    <!-- 视频区：固定高度，避免把按钮挤没 -->
    <div style="
      position:relative;
      background:#000;
      flex:0 0 auto;
      height:min(60vh, 420px);      /* 移动端占 60% 屏幕高，上限 420px */
    ">
      <video id="qr-video" playsinline muted webkit-playsinline
        style="width:100%;height:100%;object-fit:cover;background:#000;display:block"></video>
      <!-- 取景框 -->
      <div style="
        position:absolute;inset:15% 12%;
        border:2px solid rgba(255,255,255,.85);
        border-radius:12px;
        box-shadow:0 0 0 9999px rgba(0,0,0,.25);
        pointer-events:none;
      "></div>
    </div>

    <!-- 状态栏 -->
    <div id="qr-status"
      style="flex:0 0 auto;color:#fff;padding:.85rem 1rem;
             background:#161616;border-top:1px solid #222;font-size:.95rem">
      Opening camera...
    </div>

    <!-- 底部按钮栏 -->
    <div style="
      flex:0 0 auto;
      display:flex;gap:.5rem;justify-content:center;
      padding:.7rem 1rem;
      background:#161616;border-top:1px solid #222;
      position:relative;z-index:1;
    ">
      <button id="qr-close"
        style="padding:.6rem 1rem;border-radius:.6rem;
               border:1px solid #ddd;background:#fff;color:#111">
        Close
      </button>
    </div>
  </div>`;


  document.body.appendChild(overlay);

  const $video = overlay.querySelector('#qr-video');
  const $status = overlay.querySelector('#qr-status');
  const $close = overlay.querySelector('#qr-close');

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d', { willReadFrequently: true });

  // ✅ 彻底关闭相机资源
  async function hardStopCamera() {
    running = false;

    // 取消动画循环
    if (animationId) {
      cancelAnimationFrame(animationId);
      animationId = null;
    }

    try {
      // 停止所有媒体轨道
      const currentStream = $video.srcObject || stream;
      if (currentStream && typeof currentStream.getTracks === 'function') {
        currentStream.getTracks().forEach(track => {
          track.stop();
          // 确保轨道完全停止
          if (track.readyState !== 'ended') {
            track.enabled = false;
          }
        });
      }
    } catch (e) {
      console.warn('Error stopping tracks:', e);
    }

    // 清理视频元素
    try {
      $video.pause();
      $video.srcObject = null;
      // 强制清理视频源
      $video.src = '';
      $video.load();
    } catch (e) {
      console.warn('Error cleaning video:', e);
    }

    stream = null;
    overlay.style.display = 'none';

    // 等待浏览器完成清理工作
    await new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // 额外延迟确保 iOS 设备完全释放硬件
          setTimeout(resolve, 100);
        });
      });
    });
  }

  // 初始化时清理可能的遗留资源
  hardStopCamera();

  async function onResult(text) {
    $status.textContent = 'QR code detected! Redirecting...';

    // 🔑 关键：先彻底停止相机，等待清理完成
    await hardStopCamera();

    // 规范化 URL
    let url = text.trim();
    if (!/^https?:\/\//i.test(url) && !/^[\w-]+:/.test(url)) {
      url = 'https://' + url;
    }

    // 🔑 关键：使用更长的延迟确保相机完全释放
    setTimeout(() => {
      try {
        window.location.replace(url);
      } catch (e) {
        console.error('Navigation error:', e);
        window.location.replace(url);
      }
    }, 300); // 增加延迟时间
  }

  async function startScan() {
    if (running) return;

    overlay.style.display = 'flex';
    $status.textContent = 'Requesting camera access...';

    if (!navigator.mediaDevices?.getUserMedia) {
      $status.textContent = 'Camera not supported on this device.';
      return;
    }

    try {
      // 请求相机权限和流
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1280, min: 640 },
          height: { ideal: 720, min: 480 }
        },
        audio: false
      });

      $video.srcObject = stream;

      // 等待视频准备就绪
      await new Promise((resolve, reject) => {
        $video.onloadedmetadata = resolve;
        $video.onerror = reject;
        setTimeout(reject, 5000); // 5秒超时
      });

      await $video.play();

      running = true;
      $status.textContent = 'Point camera at QR code to scan...';

      // 开始扫描循环
      animationId = requestAnimationFrame(scanLoop);

    } catch (error) {
      console.error('Camera error:', error);
      let message = 'Unable to access camera. ';

      if (error.name === 'NotAllowedError') {
        message += 'Please grant camera permission and try again.';
      } else if (error.name === 'NotFoundError') {
        message += 'No camera found on this device.';
      } else if (error.name === 'NotSupportedError') {
        message += 'Camera not supported in this browser.';
      } else {
        message += error.message || 'Unknown error occurred.';
      }

      $status.textContent = message;
      setTimeout(() => hardStopCamera(), 3000);
    }
  }

  function decodeQRFromVideo() {
    const vw = $video.videoWidth;
    const vh = $video.videoHeight;

    if (!vw || !vh || vw < 100 || vh < 100) return null;

    canvas.width = vw;
    canvas.height = vh;

    try {
      ctx.drawImage($video, 0, 0, vw, vh);
      const imageData = ctx.getImageData(0, 0, vw, vh);
      const result = window.jsQR(imageData.data, vw, vh, {
        inversionAttempts: 'dontInvert'
      });

      return result?.data || null;
    } catch (e) {
      console.warn('QR decode error:', e);
      return null;
    }
  }

  function scanLoop(timestamp) {
    if (!running) return;

    // 检查视频流状态
    if (!$video.videoWidth || !$video.srcObject) {
      animationId = requestAnimationFrame(scanLoop);
      return;
    }

    // 控制扫描频率
    if (timestamp - lastTs < DETECT_INTERVAL) {
      animationId = requestAnimationFrame(scanLoop);
      return;
    }

    lastTs = timestamp;

    try {
      const qrData = decodeQRFromVideo();
      if (qrData && qrData.length > 0) {
        console.log('QR detected:', qrData);
        onResult(qrData);
        return; // 检测到后不再继续循环
      }
    } catch (e) {
      console.warn('Scan error:', e);
    }

    // 继续下一帧
    animationId = requestAnimationFrame(scanLoop);
  }

  // 事件监听器
  $close.addEventListener('click', hardStopCamera);

  // 页面可见性变化时停止相机
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      hardStopCamera();
    }
  });

  // 页面卸载时强制清理
  window.addEventListener('beforeunload', hardStopCamera);
  window.addEventListener('pagehide', hardStopCamera);

  // iOS Safari 特殊处理
  window.addEventListener('blur', () => {
    if (running) {
      setTimeout(hardStopCamera, 100);
    }
  });

  // 导出启动函数
  window.startScan = startScan;

  // 导出停止函数供外部调用
  window.stopScan = hardStopCamera;
})();